import BaseService from '@/api/base.service';
import configApi from '@/api/config';
import grapePerksAppService from '@/api';

class WaitingListService extends BaseService {
  constructor() {
    super({ baseUrl: configApi.baseRoutesUrls.waitingList });
  }

  /**
   * @function getWaitingListBrandingDetails
   * @return {Promise.<GrapePerksApiResponse>} branding details
   */
  getWaitingListBrandingDetails = (tenantUrlLinksSuffix) => grapePerksAppService.get(
    `${this.baseUrl}/branding/${tenantUrlLinksSuffix}`,
  ).then((resp) => resp.data);

  openWaitingListWorkDay = () => grapePerksAppService.put(
    `${this.baseUrl}/open-work-day/`,
  ).then((resp) => resp.data);

  closeWaitingListWorkDay = () => grapePerksAppService.put(
    `${this.baseUrl}/close-work-day`,
  ).then((resp) => resp.data);

  pauseWaitingListWorkDay = () => grapePerksAppService.put(
    `${this.baseUrl}/pause-work-day`,
  ).then((resp) => resp.data);

  resumeWaitingListWorkDay = () => grapePerksAppService.put(
    `${this.baseUrl}/resume-work-day`,
  ).then((resp) => resp.data);

  bookTurnInWaitingList = (payload, tenantUrlLinksSuffix) => grapePerksAppService.post(
    `${this.baseUrl}/book-turn/${tenantUrlLinksSuffix}`, payload,
  ).then((resp) => resp.data);

  cancelTurnInWaitingList = (
    tenantUrlLinksSuffix,
    waitingListId,
  ) => grapePerksAppService.put(
    `${this.baseUrl}/cancel-turn/${tenantUrlLinksSuffix}/${waitingListId}`, {},
  ).then((resp) => resp.data);

  recoverTurnInWaitingList = (
    tenantUrlLinksSuffix,
    waitingListId,
  ) => grapePerksAppService.put(
    `${this.baseUrl}/recover-turn/${tenantUrlLinksSuffix}/${waitingListId}`, {},
  ).then((resp) => resp.data);

  getTurnInfo = (waitingListId) => grapePerksAppService.get(
    `${this.baseUrl}/${waitingListId}`,
  ).then((resp) => resp.data);

  updateTurnStatus = (payload, id) => grapePerksAppService.put(
    `${this.baseUrl}/turn/${id}`, payload,
  ).then((resp) => resp.data);
}

const singletonInstance = new WaitingListService();

/**
 * tenant service api instance
 * @exports api/modules/tenant
 * */
export default singletonInstance;
